<template>
    <section class="section">
        <div class="container">
            <div class="content-wrapper">
                <h2>{{ $t("section.title") }}</h2>
                <p>{{ $t("section.description") }}</p>
                <img src="../../assets/images/lapton-use.png" :alt="$t('section.imageAlt')" />
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'ScrollSection'
}
</script>